import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
export class FileUploadService {

    readonly MAX_TOTAL_FILE_SIZE_MB = 50
    private readonly MAX_TOTAL_FILE_SIZE = this.MAX_TOTAL_FILE_SIZE_MB * 1024 * 1024

    hasValidSize(file: File): boolean {
        return file?.size <= this.MAX_TOTAL_FILE_SIZE
    }
}
